import React from 'react'
import { useParams } from 'react-router'

export const useBrandAccountQueryKey = () => {
  const { brandAccountId = '' } = useParams<{
    brandAccountId: string | undefined
  }>()

  return React.useMemo(
    () => ['UseBrandAccountQuery_Main', { brandAccountId }] as const,
    [brandAccountId],
  )
}
